const CargoItemTemplate = {
  EUR_PALLET: "EUR_PALLET",
  RETURNABLE_PALLET: "RETURNABLE_PALLET",
  PALLET: "PALLET",
  BOX: "BOX",
  US_PALLET: "US_PALLET",
  HALF_EUR_PALLET: "HALF_EUR_PALLET",
  BOX: "BOX",
  LDM: "LDM",
  VAN: "VAN",
  SOLO: "SOLO",
  LKW: "LKW",
  MEGA: "MEGA",
  TANDEM: "TANDEM",
  BOX_SEMI_TRAILER: "BOX_SEMI_TRAILER",
  FRIGO_SEMI_TRAILER: "FRIGO_SEMI_TRAILER"
};

export default CargoItemTemplate;
